// extracted by mini-css-extract-plugin
export default {"verifyFooter":"XNY7Tlx0v0kgxx1xwqNn","container":"qMQNEgxUHKlivc1V_JLa"};